module.exports = __webpack_public_path__ + "static/media/2 Como comprar-min.e143077e.png";